module.exports = __webpack_public_path__ + "static/media/invite_grain_bg.24f60ef8.png";